import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Link from '@welldev-group/rcl-link';
import httpClient from '../../../../shared/libraries/httpClient';
import routes from '../../../../shared/routes';
import DateTime from '../../DateTime';
import SubscriptionWaitingModal from './SubscriptionWaitingModal';
import DowngradedFeatureDetailsModal from './DowngradedFeatureDetailsModal';
import ActionConfirmationModal from './ActionConfirmationModal';
import PendingDowngradeAlert from './PendingDowngradeAlert';

const CancelScheduledDowngradeModule = ({ affiliateId, scheduledDowngrade, redirectTo }) => {
  const [showWaitingModal, setShowWaitingModal] = useState(false);
  const [showDowngradedFeatureDetailsModal, setShowDowngradedFeatureDetailsModal] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);

  const cancelDowngrade = planId => {
    setShowDowngradedFeatureDetailsModal(false);
    setShowWaitingModal(true);

    httpClient
      .delete(
        routes.billing.subscriptions.downgrade.cancel({
          affiliate_id: affiliateId,
          id: planId,
        }),
      )
      .then(() => {
        setShowWaitingModal(false);
        setShowConfirmationModal(true);
      });
  };

  return (
    <>
      <SubscriptionWaitingModal
        isVisible={showWaitingModal}
        waitingText={I18n.t('components.subscription.downgrade_waiting_text')}
      />
      <DowngradedFeatureDetailsModal
        isVisible={showDowngradedFeatureDetailsModal}
        title={I18n.t('components.subscription.subscription_feature_details_modal.downgrade.title')}
        subTitle={I18n.t(
          'components.subscription.subscription_feature_details_modal.downgrade.sub_title',
          {
            newPlanName: I18n.t(scheduledDowngrade && scheduledDowngrade.plan?.name, {
              scope: 'components.plans',
            }),
            newPlanPeriod: scheduledDowngrade?.plan?.period,
            date: DateTime({
              dateTime: scheduledDowngrade?.downgradeAt,
              format: 'short',
              returnStringOnly: true,
            }),
          },
        )}
        downgradedFeatureDetails={scheduledDowngrade?.downgradedFeatures}
        onOutsideClick={() => {
          setShowDowngradedFeatureDetailsModal(false);
        }}
        onCancelDowngrade={() => cancelDowngrade(scheduledDowngrade?.id)}
      />
      <ActionConfirmationModal
        isVisible={showConfirmationModal}
        title={I18n.t('components.subscription.downgrade_cancelation.confirmation.title')}
        subTitle={I18n.t('components.subscription.downgrade_cancelation.confirmation.sub_title')}
        footer={
          <Link type="button" size="small" modifier="primary" href={redirectTo}>
            {I18n.t(
              'components.subscription.subscription_feature_details_modal.downgrade.footer.link.close',
            )}
          </Link>
        }
      />
      <PendingDowngradeAlert
        isVisible={Boolean(scheduledDowngrade)}
        scheduledDowngrade={scheduledDowngrade}
        onClick={() => {
          setShowDowngradedFeatureDetailsModal(true);
        }}
      />
    </>
  );
};

CancelScheduledDowngradeModule.defaultProps = {
  scheduledDowngrade: null,
  redirectTo: '',
};

CancelScheduledDowngradeModule.propTypes = {
  affiliateId: PropTypes.number.isRequired,
  scheduledDowngrade: PropTypes.shape({
    id: PropTypes.number,
    plan: PropTypes.shape({
      name: PropTypes.string,
      period: PropTypes.string,
    }),
    downgradedFeatures: PropTypes.shape({
      lessWorkspaces: PropTypes.number,
      lessChannels: PropTypes.number,
      customDomainNotSupported: PropTypes.bool,
      lessPhoneSupport: PropTypes.bool,
    }),
    downgradeAt: PropTypes.string,
  }),
  redirectTo: PropTypes.string,
};

export default CancelScheduledDowngradeModule;
